import { useState } from "react";
import { SignatureCanvas } from "@/features/timesheetFlow/components/SignatureCanvas";
import {
  TimesheetFlowFooter,
  TimesheetFlowFooterButton,
} from "@/features/timesheetFlow/components/TimesheetFlowFooter";
import { submitProjectCompletion } from "@/features/timesheetFlow/timesheetFlowApi";
import type { TimesheetProjectPreset } from "@/features/timesheetFlow/timesheetFlowTypes";

/** Standardtext für die Fertigstellungsmeldung (wie klassisches Festpreis-Modal). */
export const PROJECT_COMPLETION_STATEMENT_TEXT =
  "Hiermit bestätigen wir die vollständige Fertigstellung der beauftragten Arbeiten gemäß Auftrag. Mit der Unterschrift wird der Projektabschluss dokumentiert.";

export function CompletionEditorScreen({
  project,
  onDone,
  onBack,
}: {
  project: TimesheetProjectPreset;
  onDone: () => void;
  onBack: () => void;
}) {
  const [signature, setSignature] = useState<string | null>(null);
  const [hasStrokes, setHasStrokes] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const canSubmit = hasStrokes && signature;

  const handleSubmit = async () => {
    if (!canSubmit || !signature) return;
    setBusy(true);
    setError(null);
    try {
      await submitProjectCompletion(project.id, PROJECT_COMPLETION_STATEMENT_TEXT, signature);
      onDone();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Speichern fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="mb-2 text-sm font-medium text-label">Unterschrift Monteur</p>
        <p className="mb-2 text-xs text-label-secondary">
          Mit Finger oder Maus unterschreiben — Unterschrift des Monteurs, der das Projekt fertigstellt.
        </p>
        <SignatureCanvas
          onChange={(strokes, dataUrl) => {
            setHasStrokes(strokes);
            setSignature(dataUrl);
          }}
        />
      </div>
      {error ? <p className="text-sm text-status-red">{error}</p> : null}
      <TimesheetFlowFooter>
        <TimesheetFlowFooterButton type="button" variant="secondary" onClick={onBack} disabled={busy}>
          Zurück
        </TimesheetFlowFooterButton>
        <TimesheetFlowFooterButton
          type="button"
          onClick={() => void handleSubmit()}
          disabled={!canSubmit || busy}
        >
          Fertigstellungsmeldung speichern
        </TimesheetFlowFooterButton>
      </TimesheetFlowFooter>
    </div>
  );
}
